var state = {
  promoterDrawer: false,
  flowPermission: {
    depList: [],
    userList: []
  },
  approverDrawer: false,
  approverConfig: {},
  copyerDrawer: false,
  copyerConfig: {},
  conditionDrawer: false,
  //审批设置的条件设置弹窗开启/关闭
  conditionDialog: false,
  // 低代码的条件设置弹窗开启/关闭
  fieldOptions: {},
  // 低代码触发器的条件设置内容
  conditionsConfig: {
    conditionNodes: []
  },
  formSettingProps: [],
  conditionsFields: []
};
var mutations = {
  updatePromoter: function updatePromoter(status, promoterDrawer) {
    status.promoterDrawer = promoterDrawer;
  },
  updateFlowPermission: function updateFlowPermission(status, flowPermission) {
    status.flowPermission = flowPermission;
  },
  updateApprover: function updateApprover(status, approverDrawer) {
    status.approverDrawer = approverDrawer;
  },
  updateApproverConfig: function updateApproverConfig(status, approverConfig) {
    status.approverConfig = approverConfig;
  },
  updateCopyer: function updateCopyer(status, copyerDrawer) {
    status.copyerDrawer = copyerDrawer;
  },
  updateCopyerConfig: function updateCopyerConfig(status, copyerConfig) {
    status.copyerConfig = copyerConfig;
  },
  // 关闭审批流程的条件设置
  updateCondition: function updateCondition(status, conditionDrawer) {
    status.conditionDrawer = conditionDrawer;
  },
  // 关闭低代码的条件设置弹窗
  updateConditionDialog: function updateConditionDialog(status, conditionDrawer) {
    status.conditionDialog = conditionDrawer;
  },
  uadatefieldOptions: function uadatefieldOptions(status, fieldOptions) {
    status.fieldOptions = fieldOptions;
  },
  updateConditionsConfig: function updateConditionsConfig(status, conditionsConfig) {
    status.conditionsConfig = conditionsConfig;
  },
  upDateFormSetting: function upDateFormSetting(status, props) {
    status.formSettingProps = props;
  },
  upDateConditionsField: function upDateConditionsField(status, props) {
    status.conditionsFields = props;
  }
};
var actions = {};
export default {
  state: state,
  mutations: mutations,
  actions: actions
};